import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Concerns from './components/Concerns';
import Transformation from './components/Transformation';
import Curriculum from './components/Curriculum';
import Courses from './components/Courses';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import FloatingCTA from './components/FloatingCTA';

export default function HomePage() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight * 0.5) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Concerns />
      <Transformation />
      <Curriculum />
      <Courses />
      <Testimonials />
      <FAQ />
      <FloatingCTA />
      
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-20 right-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-[#1A2B4A] hover:shadow-xl transition-all duration-300 z-40 cursor-pointer"
          aria-label="ページトップへ"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      )}
    </div>
  );
}
